import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "relative flex w-full rounded-sm card-border" }
const _hoisted_2 = {
  key: 0,
  class: "flex absolute h-full w-full bg-opacity-0 bg-dark z-10"
}
const _hoisted_3 = { class: "m-auto flex flex-col items-center space-y-2" }
const _hoisted_4 = { class: "flex md:flex-row flex-col h-full" }
const _hoisted_5 = { class: "h-full pt-2 pb-2 md:pb-0 px-4 md:pt-4 rounded-tl-sm bg-gray-50" }
const _hoisted_6 = { class: "sticky flex md:flex-col flex-row place-content-evenly items-center md:pb-4 md:space-y-4 md:space-x-0 top-18" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = { class: "text-3xl md:text-4xl text-muted" }
const _hoisted_9 = { class: "flex flex-col w-full h-full bg-black bg-opacity-0 relative" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-4xl material-icons text-success" }, "verified", -1)
const _hoisted_11 = {
  key: 1,
  class: "banner banner-light mx-2"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-muted" }, " shield ", -1)
const _hoisted_13 = { class: "" }
const _hoisted_14 = { ref: "content" }
const _hoisted_15 = {
  key: 1,
  class: "flex -mt-4 overflow-hidden"
}
const _hoisted_16 = { class: "flex w-full mt-2 pb-0.5" }
const _hoisted_17 = { class: "flex md:ml-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "edit", -1)
const _hoisted_19 = ["loading"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "delete", -1)
const _hoisted_21 = { class: "flex items-center ml-auto" }
const _hoisted_22 = { class: "md:mr-5 mr-2 text-sm md:text-base text-muted" }
const _hoisted_23 = { class: "w-full border-t px-4 py-4 border-gray-50" }
const _hoisted_24 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_ProcessedTextFragment = _resolveComponent("ProcessedTextFragment")!
  const _component_CodeFragment = _resolveComponent("CodeFragment")!
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Message = _resolveComponent("Message")!
  const _component_MessageEditor = _resolveComponent("MessageEditor")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showTeacherControls && _ctx.solution.state === _ctx.ExerciseSolutionState.REJECTED)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t("exercise_solution.you_rejected_this_solution")), 1),
              _createVNode(_component_Btn, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onUpdateState(_ctx.ExerciseSolutionState.SUBMITTED)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("misc.undo")), 1)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-col w-full", {
					'opacity-50 hover:opacity-70 ease-in-out transition-opacity duration-200':
						_ctx.solution.state === _ctx.ExerciseSolutionState.REJECTED,
				}])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Btn, {
                  disabled: _ctx.isOwnSolution,
                  variant: 'icon',
                  size: 'lg',
                  outline: true,
                  class: "relative z-10",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onVote(_ctx.VoteType.UP_VOTE)))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass([
											_ctx.solution.has_upvote ? 'material-icons' : 'material-icons-outlined',
										]),
                      style: _normalizeStyle(
											_ctx.mediaQueryMdMatches
												? 'font-size: 35px !important'
												: 'font-size: 28px !important'
										)
                    }, " thumb_up_alt", 6)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.solution.score), 1),
              _createVNode(_component_Btn, {
                disabled: _ctx.isOwnSolution,
                variant: 'icon',
                size: 'lg',
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onVote(_ctx.VoteType.DOWN_VOTE))),
                outline: true,
                class: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass([
										_ctx.solution.has_downvote ? 'material-icons' : 'material-icons-outlined',
									]),
                    style: _normalizeStyle(
										_ctx.mediaQueryMdMatches
											? 'font-size: 35px !important'
											: 'font-size: 28px !important'
									)
                  }, " thumb_down_alt", 6)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.solution.state === _ctx.ExerciseSolutionState.APPROVED)
              ? (_openBlock(), _createBlock(_component_Tooltip, {
                  key: 0,
                  textValue: _ctx.$t('exercise_solution.verified'),
                  placement: 'bottom',
                  class: "mr-3 mt-3 absolute right-0 top-0 z-10"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["textValue"]))
              : _createCommentVNode("", true),
            (
								_ctx.showTeacherControls && _ctx.solution.state === _ctx.ExerciseSolutionState.SUBMITTED
							)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("exercise_solution.teacher_is_this_solution_correct")), 1),
                  _createVNode(_component_Btn, {
                    disabled: _ctx.publishing,
                    size: 'sm',
                    class: "ml-4 mr-2",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onUpdateState(_ctx.ExerciseSolutionState.APPROVED)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("exercise_solution.approve")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_Btn, {
                    disabled: _ctx.publishing,
                    size: 'sm',
                    outline: true,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onUpdateState(_ctx.ExerciseSolutionState.REJECTED)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("exercise_solution.reject")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["relative w-full pt-4 mb-auto whitespace-pre", {
								'h-full': !_ctx.collapsed && !_ctx.calculatingHeight,
								'overflow-y-hidden': _ctx.collapsed || _ctx.calculatingHeight,
							}]),
              style: _normalizeStyle(
								_ctx.collapsed || _ctx.calculatingHeight
									? 'max-height: ' + _ctx.MAX_CONTENT_HEIGHT_PX + 'px'
									: ''
							)
            }, [
              _createElementVNode("div", _hoisted_14, [
                (_ctx.solutionType === 'text')
                  ? (_openBlock(), _createBlock(_component_ProcessedTextFragment, {
                      key: 0,
                      style: {"white-space":"break-spaces"},
                      class: "w-full px-4 py-2 rounded",
                      value: _ctx.solution.content
                    }, null, 8, ["value"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_CodeFragment, {
                        language: _ctx.solutionType,
                        value: _ctx.solution.content,
                        class: "rounded-tr rounded-none flex-grow bg-dark"
                      }, null, 8, ["language", "value"])
                    ])),
                (_ctx.collapsed)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["absolute bottom-0 left-0 flex w-full h-40", [
										_ctx.solutionType === 'text' ? 'hidden-content' : 'hidden-content-code',
									]])
                    }, [
                      _createVNode(_component_Btn, {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.collapsed = false)),
                        variant: 
											_ctx.solutionType === 'text' ? 'primary-borderless' : 'secondary'
										,
                        class: "z-20 mx-auto mt-auto mb-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("exercise_solution.reveal_solution")), 1)
                        ]),
                        _: 1
                      }, 8, ["variant"])
                    ], 2))
                  : _createCommentVNode("", true)
              ], 512)
            ], 6),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                (_ctx.canEdit)
                  ? (_openBlock(), _createBlock(_component_Btn, {
                      key: 0,
                      variant: 'icon',
                      outline: true,
                      tooltip: _ctx.$t('exercise_solution.edit'),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('editSolution')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    }, 8, ["tooltip"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_CopyToClipboard, {
                  "icon-only": true,
                  tooltip: _ctx.$t('exercise_solution.share'),
                  value: _ctx.permalink
                }, null, 8, ["tooltip", "value"]),
                _createVNode(_component_Btn, {
                  variant: 'icon',
                  outline: true,
                  tooltip: 
										_ctx.solution.is_bookmarked
											? _ctx.$t('exercise_solution.remove_bookmark')
											: _ctx.$t('exercise_solution.add_bookmark')
									
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["material-icons", { 'text-primary': _ctx.solution.is_bookmarked }]),
                      loading: _ctx.bookmarking,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onToggleBookmark()))
                    }, _toDisplayString(_ctx.solution.is_bookmarked ? "bookmark" : "bookmark_outline"), 11, _hoisted_19)
                  ]),
                  _: 1
                }, 8, ["tooltip"]),
                (_ctx.canEdit)
                  ? (_openBlock(), _createBlock(_component_Btn, {
                      key: 1,
                      class: "icon-btn-danger",
                      variant: 'icon',
                      outline: true,
                      tooltip: _ctx.$t('exercise_solution.delete'),
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('deleteSolution')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    }, 8, ["tooltip"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_Avatar, {
                  class: "ml-auto md:mr-2 mr-1",
                  user: _ctx.solution.user ?? {}
                }, null, 8, ["user"]),
                _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.authorName), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("h5", _hoisted_24, _toDisplayString(_ctx.$t("exercise_solution.comments")), 1),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solution.comments, (comment) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'comment-' + comment.id,
                class: "my-1.5"
              }, [
                _createVNode(_component_Message, {
                  canDelete: false,
                  user: comment.user,
                  message: comment.content
                }, null, 8, ["user", "message"])
              ]))
            }), 128))
          ]),
          _createVNode(_component_MessageEditor, {
            posting: _ctx.postingComment,
            onSendMessage: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onAddComment($event.message, $event.resolveFn, $event.rejectFn)))
          }, null, 8, ["posting"])
        ])
      ], 2)
    ])
  ]))
}